import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import { ContractTable } from "./Components/contractTable";

interface Props {
  id: any;
  data: any;
  documents: any;
  reviewers: any;
  watchers:any;
  refreshData?: (value: React.Key[]) => void;
  reTrigger:(arg: any) => void ;
  fullEnvelopeDetails: any;
  notification: any;
  isMobile:boolean;
}

export const OverView = ({ data,  id, documents, reviewers,reTrigger,fullEnvelopeDetails,notification,watchers,isMobile }: Props) => {

const handleTrigger = (value:any) => {
  reTrigger(value)
}

  return (
    <Row gutter={16}>
      <Col span={24}>
        <ContractTable detailsTrigger={handleTrigger} data={data} id={id} watchers={watchers} documents={documents} reviewers={reviewers} fullEnvelopeDetails={fullEnvelopeDetails} notification={notification} isMobile={isMobile}/>
      </Col>
    </Row>
  );
};
